const helperText = { id: 'orderDeliveryTimeChip.helperText' };

const textIds = { helperText };

export default textIds;
